import React from 'react';

import { ICustomRenderHeaderJSXProps } from '~/src/dash/components/tables/ListViewTable/common';
import { Div, spacing, Text } from '~/src/dash/publicaUI';

// custom render for column headers. pass in headerJSXStyle
export const CustomTextRender = (props: ICustomRenderHeaderJSXProps) => {
  const { label, column } = props;

  return (
    <Div style={{ paddingLeft: spacing.small, textAlign: 'right' }}>
      <Text small style={column.headerJSXStyle}>
        {label}
      </Text>
    </Div>
  );
};
